module.exports = __webpack_public_path__ + "img/uploadblue.74a920be.svg";